import { FieldProps } from 'formik';
import { CollectionMultiSelect } from '../collection-multiple-autocomplete';
import { FilterCollectionMultiSelect } from '../collection-multiple-autocomplete-filter';
import { CollectionAutocomplete } from '../collection-autocomplete';
import { TaskStatusEnum } from '@sr/dto';
export { TaskStatusEnum } from '@sr/dto';

export const TASK_STATUS_MAP: Record<number, string> = {
  [TaskStatusEnum.NEW]: 'Новая',
  [TaskStatusEnum.IN_PROGRESS]: 'В работе',
  [TaskStatusEnum.COMPLETED]: 'Выполнена',
  [TaskStatusEnum.CLOSED]: 'Завершенная',
};

type TaskStatusFieldProps = FieldProps<number | number[] | null, any> & { multi?: boolean; customSize?: number; compactTags?: boolean };

export const TaskStatusPickerField = ({ form, field, meta, multi = false, customSize, compactTags = false, ...rest }: TaskStatusFieldProps) => {
  const items = Object.values(TaskStatusEnum)
    .filter((v) => typeof v === 'number')
    .map((status) => ({ id: status as number, label: TASK_STATUS_MAP[status as number] }));

  return multi ? (
    compactTags ? (
      <FilterCollectionMultiSelect
        customSize={customSize}
        field={field}
        form={form}
        isLoading={false}
        items={items}
        clearable={true}
        label="Статус"
        meta={meta}
        {...rest}
      />
    ) : (
      <CollectionMultiSelect
        customSize={customSize}
        field={field}
        form={form}
        isLoading={false}
        items={items}
        clearable={true}
        label="Статус"
        meta={meta}
        {...rest}
      />
    )
  ) : (
    <CollectionAutocomplete field={field} form={form} isLoading={false} items={items} clearable={true} label="Статус" meta={meta} {...rest} />
  );
};
